<template>
    <div>
      <p>GanttProject for Linux is distributed as a standalone AppImage and as a DEB package.</p>
        <p>This is a <code>.deb</code> package built for Ubuntu/Mint Linux.
            Install it using your system package management tools, such as synaptic,
            Ubuntu software, apt, dpkg, etc. </p>

    <div class="p-3">
        <strong>GanttProject {{ version }} AppImage for Linux</strong>
        <div class="help-text pb-3">Built on {{ releaseDate }}</div>
        <a role="button" class="btn btn-attention btn-lg" :href="`/dl/${version}/lin/appimage`" v-on:click="onDownloadStarted" data-track-event="dwnl,dwnl-gp34-appimage">Download AppImage [{{ sizeAppimage }}]</a>
        <br><br>
        <ul>
          <li>AppImage package comes bundled with Java Runtime. You don't need to install Java separately.</li>
          <li>You need to make the AppImage executable before running it. You can do it with your file manager or with the command line similar to <code>chmod +x ganttproject-*.appimage</code></li>
          <!--          <li>The result of antivirus tests: <a :href="`https://www.virustotal.com/gui/file/${virustotalHashExe}/detection`">1 engine out of 58 suspects </a></li>-->
        </ul>
    </div>
      <div class="p-3">
        <strong>GanttProject {{ version }} Debian package for Linux</strong>
        <div class="help-text pb-3">Built on {{ releaseDate }}</div>
        <a role="button" class="btn btn-attention btn-lg" :href="`/dl/${version}/lin/deb`" v-on:click="onDownloadStarted" data-track-event="dwnl,dwnl-gp34-deb">Download DEB [{{ sizeDeb }}]</a>
        <br><br>
        <ul>
          <li><b>Install Java Runtime</b><br>
            <p>Java Runtime is NOT included. You have to install it separately using your package manager.
              GanttProject {{ version }} requires Java Runtime version 21, and this package will work with
              Java 21 Runtime from any major vendor, such as BellSoft Liberica, AdoptOpenJDK,
              Amazon Corretto, Azul Zulu, etc. If Java 21 Runtime is not found in your software sources,
              please refer to the instructions from vendors for adding their repositories to your system.</p>
            <p><b>GanttProject {{ version }} requires Java Runtime version 21+ with JavaFX modules. It WILL NOT WORK with
              the older Java Runtimes, such as Java 17.</b>. It may probably work with the newer Java Runtimes, such as Java 25, but it has not been extensively tested.</p>
          </li>
        </ul>
      </div>
      <h3>Maintenance updates</h3>
      <p>Maintenance updates to version {{ version }} will be delivered via our Update Channel.
        Please leave Auto-Update option in the settings switched on to let GanttProject to check for updates from time to time.
        When a new update becomes available, you will be able to review it and choose to install or skip.</p>

    </div>
</template>

<script>
import {gaSendEvent} from "@/components/Analytics";

    export default {
        name: "DownloadLin34",
        props: {
            releaseDate: String,
            sizeDeb: String,
            sizeAppimage: String,
            version: String,
            virustotalHash: String
        },
      methods: {
        onDownloadStarted: function() {
          gaSendEvent('download_started');
        }
      }
    }
</script>

<style scoped>

</style>
